import { margin, legendWidth, height, width, setUpChart, selectSvg } from '~/app/d3charts/utils/common'
import { addTitle } from '~/app/d3charts/utils/chart_header'
import { buildXScalePoint, buildYScale } from '~/app/d3charts/utils/chart_scales'
import { buildXAxis, buildYAxis, yAxisUnit } from '~/app/d3charts/utils/chart_axis'
import { color } from '~/app/d3charts/line_chart/colors'

import Tooltip from '~/app/d3charts/line_chart/tooltip'

import * as d3 from 'd3'
import 'd3-scale'

export function build(dataSets, containerSelector, title, xAxis, yAxis) {
  setUpChart(containerSelector, 0)

  const svg = selectSvg(containerSelector)
  const chart = svg.select('.chart')

  // Header - Title
  const header = svg.select('.header')
  addTitle(title, header)

  // Header - Legend
  const legend = buildLegend(svg, dataSets)

  legend
    .append('circle')
    .attr('r', 7)
    .attr('stroke-width', 3)
    .attr('fill-opacity', 0)
    .attr('stroke', function (data, index) {
      return color(index)
    })

  legend
    .append('text')
    .attr('x', 15)
    .attr('y', 7)
    .attr('font-size', '12')
    .text(function (data) {
      return data.replaceAll('_', ' ')
    })

  // Chart - X axis and grid
  const xScale = buildXScalePoint(xAxis, width(), 0.88)
  const gridCss = 'stroke-neutral-600 opacity-30'

  buildXAxis(chart, height, xScale, gridCss)

  // Chart - Y axis
  const yScale = buildYScale(yAxis, height)
  buildYAxis(chart, height, yScale, yAxisUnit)

  // Chart - Lines
  dataSets.forEach((dataSet, index) => {
    buildChart(dataSet, index)
  })

  // Chart - Tooltip
  const tooltip = new Tooltip(chart, dataSets, xScale, yAxisUnit)

  //// Hoverable Area
  chart
    .append('rect')
    .attr('transform', `translate(${xScale(xAxis[0])}, 0)`)
    .attr('width', width() - margin.right)
    .attr('height', height)
    .attr('opacity', 0)
    .on('mousemove', function (e) {
      tooltip.drawTooltip(e)
    })
    .on('mouseout', function (e) {
      tooltip.removeTooltip(e)
    })

  function buildChart(dataSet, index) {
    // chart line
    chart
      .append('path')
      .datum(dataSet.data)
      .attr('fill', 'none')
      .attr('stroke', color(index))
      .attr('stroke-width', 3)
      .attr(
        'd',
        d3
          .line()
          .curve(d3.curveBasis)
          .x(function (d) {
            return xScale(d.year)
          })
          .y(function (d) {
            return yScale(d.value)
          })
      )
    // chart dots
    if (dataSet.data.length == 1) {
      chart
        .selectAll('dot')
        .data(
          dataSet.data.filter(function (d) {
            return d
          })
        )
        .enter()
        .append('circle')
        .attr('class', 'dot')
        .attr('fill', color(index))
        .attr('cx', d => xScale(d.year))
        .attr('cy', d => yScale(d.value))
        .attr('r', 4)
    }
  }
}

function buildLegend(svg, dataSets) {
  const legendGroup = svg.select('.legend-group')

  const legendItems = dataSets.map(dataSet => dataSet.name)
  const legendItemPositions = []
  const legend = legendGroup
    .selectAll('.legend')
    .data(legendItems)
    .enter()
    .append('g')
    .attr('transform', function (d, index) {
      const itemWidth = dataSets[index].name.length * 8
      const lastWidth = legendItemPositions.length == 0 ? 0 : legendItemPositions.slice(-1)
      const newWidth = itemWidth + parseInt(lastWidth) + 30
      legendItemPositions.push(newWidth)

      return `translate(${legendWidth - legendItemPositions[index]}, 0)`
    })
    .attr('class', 'legend')

  return legend
}
